module.exports = __webpack_public_path__ + "static/img/jojopayroll.b91986f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/jojopayroll.png
// module id = 3nZz
// module chunks = 46